export default {
  table: {
    tableClass: 'table table-striped',
    ascendingIcon: 'fa fa-sort-asc',
    descendingIcon: 'fa fa-sort-desc'
  },
  pagination: {
    wrapperClass: 'btn-group',
    activeClass: 'focus',
    disabledClass: 'disabled',
    pageClass: 'btn btn-primary hide-not-focused-btn',
    linkClass: 'btn btn-primary pagination-link-btn',
    icons: {
      first: 'fa fa-angle-double-left',
      prev: 'fa fa-angle-left',
      next: 'fa fa-angle-right',
      last: 'fa fa-angle-double-right'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/vuestic-components/vuestic-datatable/data/data-table-styles.js